/* eslint-disable no-param-reassign */
import { flow } from 'mobx-state-tree';
import api from '~/api';
import type { NoesisContext } from '~/api/rest/noesis';
import { ISuggestionsModel } from './model';

const actions = (self: ISuggestionsModel) => ({
  fetch: flow(function* (params: { organization_id: string; time_zone: string; context?: NoesisContext }) {
    try {
      self.startFetching();
      const { data } = yield api.noesis.fetchSuggestions(params);
      self.data = data;
      self.finishFetching();
    } catch (e) {
      self.failFetching(e);
    }
  })
});

export default actions;
